import { defineStore } from 'pinia'


export const UseAppStore = defineStore('AppStore', {
    state: () => ({
        isOffline: !navigator.onLine,
    }),
    actions: {
        setOfflineStatus(status: boolean) {
            this.isOffline = status;
        }
    }

})